SlideView = require("views/slide")

class TitleView extends SlideView
  template: require("./template")

  serialize: ->
    data = super
    data.continueBtnText = i18n("buttons.close-lesson")
    data.hasPrompt = @options.scorm or not data.exitButton
    data

  events: ->
    "iostap .btn-next": "next"
    "iostap .btn-done": "exit"

  beforeShow: ->
    @trigger("ui", flexibleHeight: true)

  beforeHide: ->
    @trigger("ui", flexibleHeight: false)

module.exports = TitleView
